import styled from 'styled-components';

const StepWrapper = styled.div`
  padding-top: ${({ paddingTopDesktop }) => paddingTopDesktop || '64px'};
  padding-bottom: ${({ paddingBottom }) => paddingBottom || '0'};
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${({ maxWidth }) => maxWidth || '816px'};
  width: 100%;
  align-self: center;

  @media screen and (max-width: 1024px) {
    flex: 1;
    padding-top: ${({ paddingTop }) => paddingTop || '24px'};
    padding-bottom: ${({ paddingBottom }) => paddingBottom || '0'};
  }
`;

export default StepWrapper;
